import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  CustomCardColorBar,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useConferenciaOrdemColeta, { LOAD_MESSAGE } from './ConferenciaOrdemColetaHook'
import * as colors from '../../../../assets/js/colors'
import {
  formatVolumeUnitsText,
  renderOrdemColetaQuantityCell,
} from '../ordem-coleta-volume-and-units.helper'

function ConferenciaOrdemColeta({ dispatch, history, selectedTp }) {
  const { ordem } = history.location.state

  const { state, localDispatch } = useConferenciaOrdemColeta()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_INITIAL_INFO:
        dispatch(showLoadingBox('Aguarde...', LOAD_MESSAGE.GET_INITIAL_INFO))
        localDispatch.getInitialInfo(ordem.id)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (ordem) localDispatch.onInit(ordem.id)
  }, [ordem])

  return (
    <div>
      <PageHeader>Histórico de Conferencia</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div>
            <div className="p-grid" style={{ marginTop: '15px' }}>
              <div className="p-col-12">
                <span style={{ fontWeight: 600 }}>Ordem de Coleta: </span>
                {ordem.descricao}
              </div>
              <div className="p-col-6">
                <CustomCardColorBar
                  title="Total de Caixas"
                  subTitle="Vol / Uni"
                  value={formatVolumeUnitsText(
                    state.conferencia.total_caixas_vol,
                    state.conferencia.total_caixas_uni,
                  )}
                  barColor={colors.azul_claro}
                />
              </div>
              <div className="p-col-6">
                <CustomCardColorBar
                  title="Caixas Conferidas"
                  subTitle="Vol / Uni"
                  value={formatVolumeUnitsText(
                    state.conferencia.total_bipado_vol,
                    state.conferencia.total_bipado_uni,
                  )}
                  barColor={colors.azul_escuro}
                />
              </div>
            </div>
            <div style={{ marginTop: 20 }}>
              <DataTable
                value={state.conferencia.bip_history}
                header={
                  <CustomDataTableHeader
                    onChange={value => localDispatch.onGlobalFilterChange(value)}
                  />
                }
                globalFilter={state.globalFilter}
                emptyMessage="Não existe histórico a ser exibido"
                paginator={true}
                rows={10}
                style={{ textAlign: 'center' }}
                responsive
              >
                <Column field="product_name" header="Produto" style={tableCellCentered(150)} />
                <Column field="usuario" header="Quem Bipou" style={tableCellCentered()} />
                <Column
                  field="qte_biped"
                  header="Quantidade Bipada"
                  style={tableCellCentered(110)}
                  body={bip => renderOrdemColetaQuantityCell(bip, bip.qte_biped)}
                />
                <Column field="created_at" header="Criado Em" style={tableCellCentered(50)} />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapToProps)(withRouter(ConferenciaOrdemColeta))
